import { BalanceRolledUpResponse } from "../../../../api/useGetBalanceRollupDetails";

export const getIsMasterSubAccount = (
  rollup: BalanceRolledUpResponse
): boolean => {
  for (const key in rollup) {
    const rollupItem = rollup[key];
    if (rollupItem[0].isMasterAccount || rollupItem[0].isSubAccount) {
      return true;
    }
  }
  return false;
};

type RollupSimple = {
  accountType: string;
  convertedTradeBalance: number;
  convertedSettleBalance: number;
};

export const getFormatAndSumRollupData = (
  rollup: BalanceRolledUpResponse
): RollupSimple[] => {
  const accountTypesAsList = Object.entries(rollup);
  if (!accountTypesAsList.length) return [];

  const formatted = accountTypesAsList.map(([accountType, balanceData]) => {
    const sumTotals = balanceData.reduce(
      (acc, curr) => {
        acc.convertedTradeBalance += curr.convertedTradeBalance;
        acc.convertedSettleBalance += curr.convertedSettleBalance;

        return acc;
      },
      { convertedTradeBalance: 0, convertedSettleBalance: 0 }
    );

    return { ...sumTotals, accountType };
  });

  return formatted.sort((a, b) =>
    a.accountType.toUpperCase() < b.accountType.toUpperCase() ? -1 : 1
  );
};

export const getTotalSum = (balanceData: RollupSimple[], propToSum: string) => {
  if (
    balanceData.length === 0 ||
    !Object.prototype.hasOwnProperty.call(balanceData[0], propToSum)
  ) {
    return 0;
  }

  return balanceData.reduce(
    (acc: number, curr: RollupSimple) =>
      acc + Number(curr[propToSum as keyof RollupSimple]),
    0.0
  );
};

// The following util functions were copied from monorepo's apex-online/common-library/utils/stringFormatters.ts

/**
 * A simple helper function that returns the input string or or a dash if the input is undefined or null
 *
 * @returns `input` value or `–`;
 * @param value string
 * @example displayValue(account?.id)
 */
export const displayValue = (value: string | undefined | null) => {
  if (!value) {
    return "–";
  }
  return value;
};

export const formatEnumSection = (str: string) => {
  const upperString = str.toUpperCase();
  // Special case logic removed for brevity
  return upperString[0] + str.slice(1).toLowerCase();
};

export const enumToCapitalCase = (str: string | undefined | null) => {
  return displayValue(
    str &&
      str
        ?.split(/[ _]/)
        .map(part => {
          return formatEnumSection(part);
        })
        .join(" ")
  );
};
